<template>
  <div id="app">
    <section>
      <NavBar />
    </section>
    <Toasts />
    <section>
      <router-view />
    </section>
    <DialogsWrapper />
    <section>

    <footer class="footer">
      <div class="content has-text-centered">
        <div class="tags">
          <div class="tag"><RouterLink to="/about/privacy">Privacy Policy</RouterLink></div>
          <div class="tag"><RouterLink to="/about/cookies">Cookies Policy</RouterLink></div>
          <div class="tag"><RouterLink to="/about/terms">Terms and Conditions</RouterLink></div>
          <div class="tag"><RouterLink to="/about/eula">EULA</RouterLink></div>
          <div class="tag"><RouterLink to="/about/disclaimer">Disclaimer</RouterLink></div>
          <div class="tag"><RouterLink to="/about/use">Acceptable Use Policy</RouterLink></div>
        </div>
      </div>
    </footer>
    </section>
  </div>
</template>
<script>
  import NavBar from './components/partials/NavBar.vue';
  import Toasts from '@/components/Toasts.vue';
  export default {
    name: 'app',
    components: {
      NavBar,
      Toasts,
    },
    methods: {
      process_payload(payload) {
        console.log("Now, I should process the payload some how...", payload)

      },
    },
    created() {
      if (process.env.VUE_APP_ENV !== 'PROD') {
        document.title = "Evity (" + process.env.VUE_APP_ENV + ")";
      } else {
        document.title = "Evity";
      }
    },
  };
</script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>